const INVITE_KEY = "xsm_collab_invite";
const ROLE_KEY = "xsm_collab_role";

export function setCollaboratorInviteContext(payload) {
  sessionStorage.setItem(INVITE_KEY, JSON.stringify(payload));
}

export function getCollaboratorInviteContext() {
  const raw = sessionStorage.getItem(INVITE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearCollaboratorInviteContext() {
  sessionStorage.removeItem(INVITE_KEY);
}

export function setCollaboratorRoleContext(payload) {
  sessionStorage.setItem(ROLE_KEY, JSON.stringify(payload));
}

export function getCollaboratorRoleContext() {
  const raw = sessionStorage.getItem(ROLE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearCollaboratorRoleContext() {
  sessionStorage.removeItem(ROLE_KEY);
}

export function clearCollaboratorSession() {
  clearCollaboratorInviteContext();
  clearCollaboratorRoleContext();
}

export function getCollaboratorDoneKey(companyId, questionnaireVersionId) {
  if (!companyId || !questionnaireVersionId) {
    return "xsm_done_unknown";
  }

  return `xsm_done_${companyId}_${questionnaireVersionId}`;
}

// export function getCollaboratorDoneKey(inviteToken) {
//   return inviteToken ? `xsm_srq20_done_${inviteToken}` : "xsm_srq20_done";
// }
